import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Icon, Input, message, Modal, Upload } from 'antd';
import './Personalization.less';
import { CLIENT_ID } from '../../utils/constants';

class Personalization extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  uploadProps = {
    name: 'fileUpload',
    action: `/storage/file/savefile?lang=zh_CN&token=${sessionStorage.getItem(
      'token'
    )}&fromType=${CLIENT_ID}`,
    headers: { token: sessionStorage.getItem('token') },
    accept: 'image/*',
    listType: 'picture-card',
    multiple: false,
    style: { width: '100%' }
  };

  initUploadList = (list, url, name) => {
    if (list.length === 0 && url) {
      let allUrl = url.split(';');
      for (let i in allUrl) {
        list.push({
          uid: -Math.random(),
          name: name,
          status: 'done',
          response: { list: [{ fileUrl: allUrl[i] }] },
          thumbUrl: allUrl[i]
        });
      }
    }
  };

  initUploadData = (fileList, type, checkSize) => {
    return {
      ...this.uploadProps,
      fileList: fileList,
      onChange: info => {
        this.uploadChange(info, type, checkSize);
      },
      beforeUpload: file => {
        return this.check(file, checkSize, true);
      }
    };
  };

  render() {
    const {
      dispatch,
      domainDefuserPwd,
      domainBgImage,
      domainI18nLogoZH,
      domainI18nLogoEN,
      domainEmailTitleLogo,
      domainBgImageFileList,
      domainI18nLogoZHFileList,
      domainI18nLogoENFileList,
      domainEmailTitleLogoFileList
    } = this.props;
    this.initUploadList(domainI18nLogoZHFileList, domainI18nLogoZH, `中文LOGO`);
    const uploaddomainI18nLogoZH = this.initUploadData(
      domainI18nLogoZHFileList,
      'domainI18nLogoZH',
      1024 * 2
    );
    this.initUploadList(domainI18nLogoENFileList, domainI18nLogoEN, `英文LOGO`);
    const uploadDomainI18nLogoEN = this.initUploadData(
      domainI18nLogoENFileList,
      'domainI18nLogoEN',
      1024 * 2
    );
    this.initUploadList(domainBgImageFileList, domainBgImage, `背景`);
    const uploadDmainBgImage = this.initUploadData(
      domainBgImageFileList,
      'domainBgImage',
      1024 * 10
    );
    this.initUploadList(
      domainEmailTitleLogoFileList,
      domainEmailTitleLogo,
      `邮件表头`
    );
    const uploadDomainEmailTitleLogo = this.initUploadData(
      domainEmailTitleLogoFileList,
      'domainEmailTitleLogo',
      300
    );

    const {
      tempBg,
      tempLogo,
      tempLogoEN,
      tempBgFileList,
      tempLogoFileList,
      tempLogoENFileList
    } = this.props;
    this.initUploadList(tempBgFileList, tempBg, `中文LOGO`);
    const uploadTempBg = this.initUploadData(
      tempBgFileList,
      'tempBg',
      1024 * 10
    );
    this.initUploadList(tempLogoFileList, tempLogo, `英文LOGO`);
    const uploadTempLogo = this.initUploadData(
      tempLogoFileList,
      'tempLogo',
      1024 * 2
    );
    this.initUploadList(tempLogoENFileList, tempLogoEN, `英文LOGO`);
    const uploadTempLogoEN = this.initUploadData(
      tempLogoENFileList,
      'tempLogoEN',
      1024 * 2
    );
    const uploadButton = (
      <div className="upload-btn">
        <Icon type="plus" />
      </div>
    );
    const { smsSingName ,sysNameZH,sysNameEN} = this.props;
    return (
      <div className="perborder">

        <div className="person-row-title">
          <span><FormattedMessage id="per_a_16"/></span>
        </div>
        <div className="temp-person">
          <div className="person-row">
            <span className="person-label"><FormattedMessage id="per_a_17"/></span>
            <span className="person-value">
            <Input value={sysNameZH || ''} placeholder="" onChange={(e) => {
              dispatch({
                type: 'personalization/update',
                payload: { sysNameZH: e.target.value }
              });
            }}/>
           </span>
          </div>
          <div className="person-row">
            <span className="person-label"><FormattedMessage id="per_a_18"/></span>
            <span className="person-value">
            <Input value={sysNameEN || ''} placeholder="" onChange={(e) => {
              dispatch({
                type: 'personalization/update',
                payload: { sysNameEN: e.target.value }
              });
            }}/>
           </span>
          </div>
          <div className="hint-text">
            <Button type="primary" onClick={(e) => {
              this.saveSysName(sysNameEN,sysNameZH);
            }}
            ><FormattedMessage id="per_a_10"/></Button>
          </div>
        </div>

        <div className="person-row-title">
          <FormattedMessage id="per_a_1" />
        </div>
        <div className="temp-person">
          <div className="person-row">
            <span className="person-label">
              <FormattedMessage id="per_a_2" />
            </span>
            <span className="person-value">
              <Upload {...uploaddomainI18nLogoZH}>
                {domainI18nLogoZHFileList.length === 0 && uploadButton}
              </Upload>
            </span>
          </div>
          <div className="person-row">
            <span className="person-label">
              <FormattedMessage id="per_a_3" />
            </span>
            <span className="person-value">
              <Upload {...uploadDomainI18nLogoEN}>
                {domainI18nLogoENFileList.length === 0 && uploadButton}
              </Upload>
            </span>
          </div>
          <div className="hint-text">
            <FormattedMessage id="per_a_4" />
          </div>
          {/*<div className="person-row">*/}
          {/*<span className="person-label">背景</span>*/}
          {/*<span className="person-value">*/}
          {/*<Upload {...uploadDmainBgImage}>*/}
          {/*{domainBgImageFileList.length < 2 && uploadButton}*/}
          {/*</Upload>*/}
          {/*</span>*/}
          {/*</div>*/}
          {/*<div className="hint-text">*/}
          {/*推荐上传1920*1080像素，照片格式可以为jpeg / jpg / png, 大小不超过2M*/}
          {/*</div>*/}
        </div>
        <div className="person-row-title">
          <FormattedMessage id="per_a_5" />
        </div>
        <div className="temp-person">
          <div className="person-row">
            <span className="person-label">
              <FormattedMessage id="per_a_2" />
            </span>
            <span className="person-value">
              <Upload {...uploadTempLogo}>
                {tempLogoFileList.length === 0 && uploadButton}
              </Upload>
            </span>
          </div>
          <div className="person-row">
            <span className="person-label">
              <FormattedMessage id="per_a_3" />
            </span>
            <span className="person-value">
              <Upload {...uploadTempLogoEN}>
                {tempLogoENFileList.length === 0 && uploadButton}
              </Upload>
            </span>
          </div>
          <div className="hint-text">
            <FormattedMessage id="per_a_6" />
          </div>
          <div className="person-row">
            <span className="person-label">
              <FormattedMessage id="per_a_7" />
            </span>
            <span className="person-value">
              <Upload {...uploadTempBg}>
                {tempBgFileList.length === 0 && uploadButton}
              </Upload>
            </span>
          </div>
          <div className="hint-text">
            <FormattedMessage id="per_a_8" />
          </div>
        </div>
        <div className="person-row-title">
          <span>
            <FormattedMessage id="per_a_9" />
          </span>
        </div>
        <div className="temp-person">
          <div className="person-row">
            <span className="person-label">
              <FormattedMessage id="per_a_9" />
            </span>
            <span className="person-value">
              <Input
                value={smsSingName || ''}
                placeholder=""
                onChange={e => {
                  dispatch({
                    type: 'personalization/update',
                    payload: { smsSingName: e.target.value }
                  });
                }}
              />
            </span>
          </div>
          <div className="hint-text">
            <FormattedMessage id="domain_sms_sign_hint" />
          </div>
          <div className="hint-text">
            <Button
              type="primary"
              onClick={e => {
                this.saveSmsSingName(smsSingName);
              }}
            >
              <FormattedMessage id="per_a_10" />
            </Button>
          </div>
        </div>
        <div className="person-row-title">
          <span>
            <FormattedMessage id="per_a_11" />
          </span>
        </div>
        <div className="temp-person">
          <div className="person-row">
            <span className="person-label">
              <FormattedMessage id="per_a_12" />
            </span>
            <span className="person-value">
              <Upload {...uploadDomainEmailTitleLogo}>
                {domainEmailTitleLogoFileList.length === 0 && uploadButton}
              </Upload>
            </span>
          </div>
          <div className="hint-text">
            <FormattedMessage id="per_a_13" />
          </div>
        </div>
        <div className="person-row-title">
          <span>
            <FormattedMessage id="per_a_14" />
          </span>
        </div>
        <div className="temp-person">
          <div className="person-row">
            <span className="person-label">
              <FormattedMessage id="per_a_15" />
            </span>
            <span className="person-value">
              <Input
                value={domainDefuserPwd || ''}
                placeholder="*****"
                onChange={e => {
                  dispatch({
                    type: 'personalization/update',
                    payload: { domainDefuserPwd: e.target.value }
                  });
                }}
              />
            </span>
          </div>
          <div className="hint-text">
            <Button
              type="primary"
              onClick={e => {
                this.saveDomainDefuserPwd(domainDefuserPwd);
              }}
            >
              <FormattedMessage id="per_a_10" />
            </Button>
          </div>
        </div>
      </div>
    );
  }
  saveDomainDefuserPwd = domainDefuserPwd => {
    const { dispatch, intl } = this.props;
    if (!domainDefuserPwd) {
      Modal.error({
        content: intl.formatMessage({ id: 'per_user_pwd_not_empty' })
      });
    } else {
      dispatch({
        type: 'personalization/saveDomainInformation',
        domainInformation: { type: 'domainDefuserPwd', value: domainDefuserPwd }
      });
    }
  };
  saveSmsSingName = smsSingName => {
    const { dispatch } = this.props;
    dispatch({
      type: 'personalization/setSmsSingName',
      smsSingName: smsSingName
    });
  };
  saveSysName = (sysNameEN,sysNameZH) => {
    const { dispatch } = this.props;
    dispatch({
      type: 'personalization/setSysName',
      sysNameEN: sysNameEN,
      sysNameZH:sysNameZH
    });

  };

  uploadChange = (info, type, size) => {
    const { dispatch, intl } = this.props;
    let { fileList, file } = info;
    if (file.name.indexOf('&') > -1) {
      file.name = file.name.replace(/&/g, '$');
    }
    let url = '';
    switch (file.status) {
      case 'error':
        fileList = [];
        Modal.error({
          title: 'ERROR',
          content: intl.formatMessage({ id: 'per_b_1' }),
          okText: intl.formatMessage({ id: 'per_b_2' })
        });
      case 'done':
      case 'removed':
        if (fileList.length > 0) {
          url = fileList[0].response.list[0].fileUrl;
          for (let i = 1; i < fileList.length; i++) {
            url += ';' + fileList[i].response.list[0].fileUrl;
          }
        }
        break;
    }
    //fileList = this.check(file, 1024*10) ? fileList : [];
    fileList = this.check(file, size) ? fileList : [];
    const { domainI18nLogoZH, domainI18nLogoEN } = this.props;
    switch (type) {
      case 'domainBgImage':
        dispatch({
          type: 'personalization/update',
          payload: { domainBgImageFileList: fileList, domainBgImage: url }
        });
        dispatch({
          type: 'menu/updateLogoBg',
          payload: { domainBgImage: url }
        });
        break;
      case 'domainI18nLogoZH':
        dispatch({
          type: 'personalization/update',
          payload: { domainI18nLogoZHFileList: fileList, domainI18nLogoZH: url }
        });
        dispatch({
          type: 'menu/updateLogoBg',
          logoBg: { domainI18nLogoZH: url, domainI18nLogoEN: domainI18nLogoEN }
        });
        break;
      case 'domainI18nLogoEN':
        dispatch({
          type: 'personalization/update',
          payload: { domainI18nLogoENFileList: fileList, domainI18nLogoEN: url }
        });
        dispatch({
          type: 'menu/updateLogoBg',
          logoBg: { domainI18nLogoZH: domainI18nLogoZH, domainI18nLogoEN: url }
        });
        break;
      case 'domainEmailTitleLogo':
        dispatch({
          type: 'personalization/update',
          payload: {
            domainEmailTitleLogoFileList: fileList,
            domainEmailTitleLogo: url
          }
        });
        break;
      case 'tempBg':
        dispatch({
          type: 'personalization/update',
          payload: { tempBgFileList: fileList, tempBg: url }
        });
        break;
      case 'tempLogo':
        dispatch({
          type: 'personalization/update',
          payload: { tempLogoFileList: fileList, tempLogo: url }
        });
        break;
      case 'tempLogoEN':
        dispatch({
          type: 'personalization/update',
          payload: { tempLogoENFileList: fileList, tempLogoEN: url }
        });
        break;
    }
    if (file.status == 'done' || file.status == 'removed') {
      switch (type) {
        case 'domainBgImage':
        case 'domainI18nLogoZH':
        case 'domainI18nLogoEN':
        case 'domainEmailTitleLogo':
          dispatch({
            type: 'personalization/saveDomainInformation',
            domainInformation: { type: type, value: url }
          });
          break;
        case 'tempBg':
        case 'tempLogo':
        case 'tempLogoEN':
          dispatch({
            type: 'personalization/saveDefTempSettingLogoBg',
            defTempSettingLogoBg: { type: type, url: url }
          });
          break;
      }
    }
  };
  check = (file, size, flag) => {
    const {intl} = this.props;
    if (!/\.(JPG|JPEG|PNG)$/.test(file.name.toLocaleUpperCase())) {
      flag && message.error(intl.formatMessage({ id: 'per_b_3' }));
      return false;
    }
    if (file.size / 1024 > size) {
      flag && message.error(intl.formatMessage({ id: 'per_b_4' }));
      return false;
    }
    return true;
  };
}

const mapStateToProps = state => {
  const { personalization } = state;
  return { ...personalization };
};

export default connect(mapStateToProps)(injectIntl(Personalization));



// WEBPACK FOOTER //
// ./src/routes/Personalization/Personalization.js